import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

const FAQSection = ({ isDarkMode }) => {
  const [openIndices, setOpenIndices] = useState(new Set());

  const toggleFAQ = (index) => {
    setOpenIndices(prev => {
      const newSet = new Set(prev);
      if (newSet.has(index)) {
        newSet.delete(index);
      } else {
        newSet.add(index);
      }
      return newSet;
    });
  };

  const faqs = [
    {
      question: 'Is CivicDuty only available in Georgia?',
      answer: 'Yes, right now we\'re focused exclusively on Georgia and specifically the Georgia State Legislature. We\'re beta testing during the 2026 Legislative Session to refine the platform before expanding further.',
      hasBullets: false
    },
    {
      question: 'Do you plan to expand beyond Georgia?',
      answer: 'Absolutely. Our goal is to expand to local government bodies within Georgia first—like the Public Service Commission, County Commissions, Boards of Education, and City Councils. If we can get support from users and legislators, we hope to eventually cover other states and provide complete government transparency across the United States.',
      hasBullets: false
    },
    {
      question: 'How do you stay nonpartisan?',
      answer: 'We strictly follow these principles:',
      bullets: [
        'We only use official sources generated by elected officials themselves—no news outlets, no commentary, no external interpretation',
        'We encourage users to report anything that might seem biased or incorrect within our AI summaries through our reporting feature',
        'Our users help us stay nonpartisan—the more feedback we collect on instances where bias may be leaking through, the more we can refine our AI to avoid making the same mistakes, improving future summaries to remain as nonpartisan as possible',
        'Every summary links back to the original official source so users can verify information themselves'
      ],
      hasBullets: true
    },
    {
      question: 'Is CivicDuty free to use?',
      answer: 'CivicDuty is currently in beta, so it\'s free for all users. We may add paid features later to help support development, but free users will always be able to come to our site and easily see everything that affects them as an individual voter. Paid features will always be for additional things—not restricting already public information.',
      hasBullets: false
    }
  ];


  return (
    <section className="bg-[#ef4444] py-16 md:py-20">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Heading */}
        <h2 className="text-4xl md:text-5xl font-bold text-white text-center mb-12">
          Frequently Asked Questions
        </h2>

        {/* FAQ Items */}
        <div>
          {faqs.map((faq, index) => (
            <div key={index}>
              <div className="bg-[#ef4444]">
                <button
                  onClick={() => toggleFAQ(index)}
                  className="w-full px-6 py-4 flex items-center justify-between text-left text-white hover:bg-[#dc2626] transition-colors"
                >
                  <span className="text-lg font-semibold pr-4">{faq.question}</span>
                  <ChevronDown
                    className={`w-5 h-5 flex-shrink-0 transition-transform text-gray-300 ${
                      openIndices.has(index) ? 'rotate-180' : ''
                    }`}
                  />
                </button>
                {openIndices.has(index) && (
                  <div className="px-6 pb-4 bg-[#ef4444]">
                    {faq.hasBullets ? (
                      <>
                        <p className="text-white leading-relaxed mb-4">{faq.answer}</p>
                        <ul className="space-y-3 text-white">
                          {faq.bullets.map((bullet, bulletIndex) => (
                            <li key={bulletIndex} className="flex items-start">
                              <span className="w-2 h-2 rounded-full bg-white mt-2 mr-3 flex-shrink-0"></span>
                              <span className="leading-relaxed">{bullet}</span>
                            </li>
                          ))}
                        </ul>
                      </>
                    ) : (
                      <p className="text-white leading-relaxed">{faq.answer}</p>
                    )}
                  </div>
                )}
              </div>
              {index < faqs.length - 1 && (
                <div className="border-b" style={{ borderColor: '#f46a69' }}></div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
